import {
  Directive,
  ElementRef,
  forwardRef,
  AfterViewInit,
  OnDestroy
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import Quill from 'quill';

@Directive({
    selector: '[appQuillEditor]',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => QuillEditorDirective),
            multi: true
        }
    ],
    standalone: false
})
export class QuillEditorDirective
  implements ControlValueAccessor, AfterViewInit, OnDestroy {

  private quill!: Quill;
  private onChange = (_: any) => {};
  private onTouched = () => {};

  constructor(private el: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    this.quill = new Quill(this.el.nativeElement, {
      theme: 'snow',
      placeholder: "Taper votre message ici...",
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline'],
          [{ header: [1, 2, 3, false] }],
          [{ font: [] }],
          [{ size: [] }],
          [{ align: [] }],
          [{ color: [] }, { background: [] }],
          [{ list: 'ordered' }, { list: 'bullet' }],
          ['link', 'image'],
          ['clean']
        ]
      }

    });

    this.quill.on('text-change', () => {
      this.onChange(this.quill.root.innerHTML);
      this.onTouched();
    });
  }

  writeValue(value: string | null): void {
    if (this.quill && value !== this.quill.root.innerHTML) {
      this.quill.clipboard.dangerouslyPasteHTML(value ?? '');    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.quill?.enable(!isDisabled);
  }

  ngOnDestroy(): void {
    this.quill?.off('text-change');
  }
}